import MarketingImage from '../../assets/images/3d-icons/marketing.png';
import AnimationImage from '../../assets/images/3d-icons/animation.png';
import MaterialLoanImage from '../../assets/images/3d-icons/material-loan.png';
import ReturnPolicyImage from '../../assets/images/3d-icons/return-policy.png';
import MerchandisingImage from '../../assets/images/3d-icons/merchandising.png';
import { CompanyServices } from '../../common/models/user.models';

export type Service = 'provide_animation' | 'provide_marketing' | 'provide_electrical_appliance' | 'provide_merchandising' | 'provide_return_policy';
export type ServiceDetails = 'animation_details' | 'marketing_details' | 'electrical_appliance_details' | 'merchandising_details' | 'return_policy_details';

export interface ServiceConfiguration {
  icon: string;
  wordingNamespace: string;
  service: Service;
  serviceDetails: ServiceDetails;
  getServiceValues?: (companyServices: CompanyServices) => unknown;
}

export const ServiceConfigurations: ServiceConfiguration[] = [
  {
    icon: MerchandisingImage,
    wordingNamespace: 'merchandising',
    service: 'provide_merchandising',
    serviceDetails: 'merchandising_details',
  },
  {
    icon: ReturnPolicyImage,
    wordingNamespace: 'return_policy',
    service: 'provide_return_policy',
    serviceDetails: 'return_policy_details',
    getServiceValues: (companyServices: CompanyServices) => companyServices.return_policy,
  },
  {
    icon: MaterialLoanImage,
    wordingNamespace: 'electrical_appliance',
    service: 'provide_electrical_appliance',
    serviceDetails: 'electrical_appliance_details',
  },
  {
    icon: MarketingImage,
    wordingNamespace: 'marketing',
    service: 'provide_marketing',
    serviceDetails: 'marketing_details',
    getServiceValues: (companyServices: CompanyServices) => companyServices.marketing_supports.map(({ support }) => support),
  },
  {
    icon: AnimationImage,
    wordingNamespace: 'animation',
    service: 'provide_animation',
    serviceDetails: 'animation_details',
  },
];
